// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalfeedback_box__ntLYw{
    width: 513px;
    height: 472px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #F2F4F8;
    border-radius: 10px;
    border: 2px solid #9E184B;
    padding: 20px;
    
}
.modalfeedback_imojis__Tr5KQ{
    display: flex;
    align-items: center;
    justify-content: space-around;

}

.modalfeedback_containerEmoji__SfKoW{
    text-align: center;
}

.modalfeedback_emojiBorda__ZkrLd{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border: 2px solid transparent;
    border-radius: 50%;
    height: 70px;
    width: 70px;
    transition: transform 300ms ease-in-out;

}

.modalfeedback_emojiBorda__ZkrLd:hover{
    transform: scale(1.2);
    border: 2px solid #9E184B;;
    border-radius: 100%;
}



.modalfeedback_imojis__Tr5KQ span{
    font-size: 40px;
}


.modalfeedback_emojiBordaVisu__ZQ24b{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border: 2px solid transparent;
    border-radius: 50%;
    height: 70px;
    width: 70px;
}

.modalfeedback_razoesParaNota__AAXKt{
    border: 2px solid #A0A0A0;
    border-radius: 10px;
    width: 95%;
    height: 100px;
    padding: 10px;
}

.modalfeedback_titulo__aMo2Z{
  text-align: center;
}

.modalfeedback_detalhe__If2Wd{
    text-align: center;
    align-items: center ;
}

.modalfeedback_clickable__6f-Zs {
    color: #9E184B;
    cursor: pointer;
    font-weight: 450;
    transition: 150ms linear;
}

.modalfeedback_clickable__6f-Zs:hover {
    transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/paginas/historico/Modal/modalfeedback.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;;AAEjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;;AAEjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uCAAuC;;AAE3C;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;;;AAIA;IACI,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,aAAa;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".box{\n    width: 513px;\n    height: 472px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #F2F4F8;\n    border-radius: 10px;\n    border: 2px solid #9E184B;\n    padding: 20px;\n    \n}\n.imojis{\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n\n}\n\n.containerEmoji{\n    text-align: center;\n}\n\n.emojiBorda{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    border: 2px solid transparent;\n    border-radius: 50%;\n    height: 70px;\n    width: 70px;\n    transition: transform 300ms ease-in-out;\n\n}\n\n.emojiBorda:hover{\n    transform: scale(1.2);\n    border: 2px solid #9E184B;;\n    border-radius: 100%;\n}\n\n\n\n.imojis span{\n    font-size: 40px;\n}\n\n\n.emojiBordaVisu{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    border: 2px solid transparent;\n    border-radius: 50%;\n    height: 70px;\n    width: 70px;\n}\n\n.razoesParaNota{\n    border: 2px solid #A0A0A0;\n    border-radius: 10px;\n    width: 95%;\n    height: 100px;\n    padding: 10px;\n}\n\n.titulo{\n  text-align: center;\n}\n\n.detalhe{\n    text-align: center;\n    align-items: center ;\n}\n\n.clickable {\n    color: #9E184B;\n    cursor: pointer;\n    font-weight: 450;\n    transition: 150ms linear;\n}\n\n.clickable:hover {\n    transform: scale(1.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `modalfeedback_box__ntLYw`,
	"imojis": `modalfeedback_imojis__Tr5KQ`,
	"containerEmoji": `modalfeedback_containerEmoji__SfKoW`,
	"emojiBorda": `modalfeedback_emojiBorda__ZkrLd`,
	"emojiBordaVisu": `modalfeedback_emojiBordaVisu__ZQ24b`,
	"razoesParaNota": `modalfeedback_razoesParaNota__AAXKt`,
	"titulo": `modalfeedback_titulo__aMo2Z`,
	"detalhe": `modalfeedback_detalhe__If2Wd`,
	"clickable": `modalfeedback_clickable__6f-Zs`
};
export default ___CSS_LOADER_EXPORT___;
